import React from "react";
import HeatMapGrid from "react-heatmap-grid";

import '../../assets/styles/App.css';
import "@fontsource/montserrat";


export default function Heatmap(props) {
  const screenSize = (window.innerWidth >= 768);

//   console.log('chart:', {props});

  return (
      <>
          <div className="relative container mx-auto mb-12 mt-4">
              <div className="w-full">
                  <p className={`text-yellow text-16-19 mb-4 ${screenSize && 'px-8'}`}>{props.title}</p>
                  <div className="text-white relative h-400-px">
                      <HeatMapGrid
                          xLabels={props.xLabels}
                          yLabels={props.yLabels}
                          data={props.data}
                          cellStyle={(background, value, min, max, data, x, y) => ({
                              background: `rgb(0, 116, 224, ${1 - (max - value) / (max - min)})`,
                              fontSize: "11.5px",
                              color: "#fff"
                          })}
                          cellRender={(value) => (value === 0 ? '' : `${value}%`)}
                          yLabelWidth={150}
                      /> 
                  </div>
              </div>
          </div>
      </>
  );
}
